import { Controller } from "@hotwired/stimulus";
import { initFeriasBulkApproval } from "../../modules/ferias/bulk_approval";
import { createFeriasApprovalsService } from "../../services/ferias_approvals_service";
import { initFeriasDeleteAction } from "../../modules/ferias/delete_action";
import { initFeriasIndexSearch } from "../../modules/ferias/index_search";
import { initFeriasAgendadasActions } from "../../modules/ferias/agendadas_actions";
import { initFeriasDropdownActions } from "../../modules/ferias/dropdown_actions";

export default class extends Controller {
  static values = {
    bulkUrl: String,
  };

  connect() {
    this.service = createFeriasApprovalsService({
      bulkUrl: this.bulkUrlValue,
    });

    this.bulk     = initFeriasBulkApproval(this.element, this.service);
    this.delete   = initFeriasDeleteAction(this.element);
    this.search   = initFeriasIndexSearch(this.element);
    this.actions  = initFeriasAgendadasActions(this.element);
    this.dropdown = initFeriasDropdownActions(this.element);
  }

  disconnect() {
    this.bulk?.destroy?.();
    this.delete?.destroy?.();
    this.search?.destroy?.();
    this.actions?.destroy?.();
    this.dropdown?.destroy?.();
  }
}
